export default __webpack_public_path__ + "static/media/pwd_type_3_3.62c75550.png";